import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { Vehicle as VehicleModel } from 'models/vehicles';
import Brand from 'models/brand';
import get from 'lodash/get';
import LicensePlateField from 'components/account/saved-vehicles/vehicle-form/license-plate-field';
import withErrors from 'containers/form-validation/error-wrapper';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  vehicle: PropTypes.instanceOf(VehicleModel),
  saveOrUpdateVehicle: PropTypes.func.isRequired,
  errors: PropTypes.instanceOf(Map).isRequired,
  setErrors: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedVehicleId: null,
  vehicle: new VehicleModel({}),
};

export class VehicleForm extends Component {
  constructor(props) {
    super(props);
    const { vehicle } = props;
    const plate = get(vehicle, 'plateNumber', '');

    this.save = this.save.bind(this);
    this.onLicensePlateChange = this.onLicensePlateChange.bind(this);

    this.state = {
      licensePlate: plate,
    };
  }

  save(e) {
    e.preventDefault();
    e.stopPropagation();

    const { vehicle, saveOrUpdateVehicle, setErrors } = this.props;
    const { licensePlate } = this.state;

    const label = this.label.value;
    const id = vehicle ? vehicle.id : null;
    const savedVehicle = new VehicleModel({ id, label, plate_number: licensePlate });
    const error = this.licensePlateField.getValidationError();

    if (error) {
      setErrors(error);
    } else {
      saveOrUpdateVehicle(savedVehicle);
    }
  }

  onLicensePlateChange(licensePlate) {
    this.setState({ licensePlate });
  }

  render() {
    const {
      vehicle,
      brand,
      errors,
      dismissError,
    } = this.props;
    const { licensePlate } = this.state;
    const description = vehicle ? vehicle.label : '';
    const buttonClasses = cx({
      'btn btn-lg btn-block btn-primary': true,
      'btn-bp': brand.isBestParking,
    });
    return (
      <fieldset>
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="form-group">
              <label htmlFor="description">VEHICLE NAME (nickname):</label>
              <input ref={(label) => { this.label = label; }} type="text" id="vehicle-description" name="description" defaultValue={description} className="form-control" placeholder="My Car" />
            </div>
          </div>
          <div className="col-lg-8 col-md-12">
            <LicensePlateField
              ref={(input) => { this.licensePlateField = input; }}
              isRequired
              value={licensePlate}
              onChange={this.onLicensePlateChange}
              errors={errors}
              dismissError={dismissError}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <input type="submit" value="SAVE VEHICLE" className={buttonClasses} onClick={this.save} />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group xs-align-center">
              <Link
                to={{ pathname: '/account/vehicles/' }}
                className="btn btn-lg btn-link btn-block"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </fieldset>
    );
  }
}

VehicleForm.propTypes = propTypes;
VehicleForm.defaultProps = defaultProps;

export default withErrors(VehicleForm);
